import { AnyAction, CombinedState, combineReducers } from '@reduxjs/toolkit';

import activeBorrowerInformationReducer from 'handlers/activeBorrowerInformationSlice';
import applicationDetailsCardsReducer from 'handlers/applicationDetailsCardsSlice';
import applicationDetailsGroupsReducer from 'handlers/applicationDetailsGroupsSlice';
import ApplicationDetailsVariableConfigurationsReducer from 'handlers/applicationDetailsVariableConfigurationsSlice';
import applicationDocumentConfigurationReducer from 'handlers/applicationDocumentConfigurationSlice';
import applicationsReducer from 'handlers/applicationsSlice';
import authReducer, { AccountsActionType } from 'handlers/authSlice';
import automationWorkflowReducer from 'handlers/automationWorkflowSlice';
import borrowerProfileCardsReducer from 'handlers/borrowerProfileCardsSlice';
import borrowerProfileGroupsReducer from 'handlers/borrowerProfileGroupsSlice';
import BorrowerProfileVariableConfigurationsReducer from 'handlers/borrowerProfileVariableConfigurationsSlice';
import borrowersReducer from 'handlers/borrowersSlice';
import commentsReducer from 'handlers/commentsSlice';
import documentsReducer from 'handlers/documentsSlice';
import productsReducer from 'handlers/productsSlice';
import snacksReducer from 'handlers/snacksSlice';
import { IReduxState } from 'types/ReduxState';

import applicationProcessReducer from './curo-handlers/applicationProcessSlice';
import applyProcessReducer from './curo-handlers/applyProcessSlice';
import signInProcessReducer from './curo-handlers/signInProcessSlice';
import verificationProcessReducer from './curo-handlers/verificationProcessSlice';
import currentApplicationDataReducer from './currentApplicationDataSlice';
import layoutConfigurationsReducer from './layoutConfigurationsSlice';
import notificationsReducer from './notificationsSlice';
import portalPageCardsReducer from './portalPageCardsSlice';
import portalPageElementsReducer from './portalPageElementsSlice';
import portalPageGroupsReducer from './portalPageGroupsSlice';
import portalPageVariableConfigurationsReducer from './portalPageVariableConfigurationsSlice';
import settingsReducer from './settingsSlice';
import tasksReducer from './tasksSlice';
import variablesReducer from './variablesSlice';

const appReducer = combineReducers<IReduxState>({
  auth: authReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
  applications: applicationsReducer,
  borrowers: borrowersReducer,
  applicationDocuments: documentsReducer,
  snacks: snacksReducer,
  products: productsReducer,
  applicationDetailsGroups: applicationDetailsGroupsReducer,
  applicationDetailsCards: applicationDetailsCardsReducer,
  applicationDetailsVariableConfigurations: ApplicationDetailsVariableConfigurationsReducer,
  borrowerProfileGroups: borrowerProfileGroupsReducer,
  borrowerProfileCards: borrowerProfileCardsReducer,
  borrowerProfileVariableConfigurations: BorrowerProfileVariableConfigurationsReducer,
  applicationDocumentsConfiguration: applicationDocumentConfigurationReducer,
  variables: variablesReducer,
  layoutConfigurations: layoutConfigurationsReducer,
  activeBorrowerInformation: activeBorrowerInformationReducer,
  portalPageElements: portalPageElementsReducer,
  tasks: tasksReducer,
  currentApplicationData: currentApplicationDataReducer,
  automationWorkflows: automationWorkflowReducer,
  portalPageGroups: portalPageGroupsReducer,
  portalPageCards: portalPageCardsReducer,
  portalPageVariableConfigurations: portalPageVariableConfigurationsReducer,
  comments: commentsReducer,

  // Curo handlers
  applyProcess: applyProcessReducer,
  signInProcess: signInProcessReducer,
  applicationProcess: applicationProcessReducer,
  verificationProcess: verificationProcessReducer,
});

const rootReducer = (
  state: IReduxState | undefined,
  action: AnyAction,
): CombinedState<IReduxState> => {
  if (!state) {
    return appReducer(state, action);
  }

  let nextState: Partial<IReduxState> = state;

  if (
    action.type === `${AccountsActionType.Logout}/fulfilled` ||
    action.type === `${AccountsActionType.Logout}/rejected`
  ) {
    nextState = {
      settings: state.settings,
    };
  }

  return appReducer(nextState as IReduxState, action);
};

export default rootReducer;
